export default __webpack_public_path__ + "static/media/Distributed  Ledger.6bb4c0ac.png";